<section class="gallery-page">
	<div class="container">
		<h1>Galéria</h1>

		<div class="grid">
            @for (image of images; track $index) {
				<div class="thumb" (click)="open($index)" tabindex="0" role="button" aria-label="Kép megnyitása: {{image.caption || image.alt}}">
					<img [src]="getThumbPath(image.src)" [alt]="image.alt || 'Kép'" loading="lazy" (error)="onThumbError($event, image.src)" />
				</div>
			}
		</div>
	</div>

	@if(selectedImage) {
		<div class="lightbox" (click)="close()">
			<div class="lightbox-inner" (click)="$event.stopPropagation()" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
				<button class="close" (click)="$event.stopPropagation(); close()" aria-label="Bezárás">✕</button>
				<div #slider class="slider" (click)="onSliderClick($event)">
					<button class="nav prev" (click)="$event.stopPropagation(); prev()" aria-label="Előző kép">‹</button>
					<img class="large current" [src]="selectedImage.src" [alt]="selectedImage.alt || 'Kép'" (click)="onImageClick($event)" />
					<button class="nav next" (click)="$event.stopPropagation(); next()" aria-label="Következő kép">›</button>
				</div>
                <div class="caption" (click)="$event.stopPropagation(); close()">{{selectedImage.caption}}</div>
            </div>
        </div>
    }
</section>

